export default __webpack_public_path__ + "static/media/csharp-icon.61929460.svg";